(function() {
  'use strict';
  angular.module('common')
  .filter('historyIdentifier', function() {
    return function(member) {
      if(member.eventData.eventName == "Lookup Eligibility") {
        return "B";
      } else if(member.eventData.eventName == "Claim Detail") {
        return "C";
      } else {
        return "";
      }
    };
  });
})();
